<template>
  <div class="offer-wrapper">
    <div class="shadow"></div>
    <div >
      <h5 class="h5-small pointer" @click="showDetails()">
        {{ this.game.name }}
      </h5>
    </div>
    <div>
      <p class="description" v-html="this.game.description.substring(0,50)"></p>
    </div>
    <div v-if="this.editable">
      <a @click="editGameDetails()" class="edit">
        <img src="@/assets/images/cms-mkt/edit.svg" />
      </a>
      <a @click="approveGame()" class="approve" v-if="isUserAdmin(user)">
        <img src="@/assets/images/cms-mkt/check.svg" />
      </a>
      <a @click="deleteGame()" class="delete">
        <img src="@/assets/images/cms-mkt/delete.svg" />
      </a>
    </div>
<br/>
    <div>
      <img class="personimg" :src="getImagePath() + 'users/' + user.id + '.png'"
        @error="($event.target.src = require('@/assets/images/cms-mkt/offer_0.svg'))" />
    </div>
  </div>
</template>

<script>

export default {
  name: "GameCase",
  components: {},

  props: {
    editable: Boolean,
    user: Object,
    game: Object,
    image: String,
  },
  data() {
    return {
      // gameData: null,
    };
  },
  methods: {
    showDetails() {
      this.$emit("showdetails", this.game);
    },
    editGameDetails() {
      this.$emit("edit", this.game);
    },
    deleteGame() {
      this.$emit("delete", this.game);
    },
    approveGame() {
      this.$emit("approve", this.game);
    }
  }, 
};
</script>
<style scoped src="@/assets/styles/mkt-cms.css"></style>
